.container {
	display: flex;
	flex: 1;
	flex-direction: column;
}
